import axiosInstance from './index';
var httpPost = function (url, requestConfig) {
    return axiosInstance
        .post(url, requestConfig === null || requestConfig === void 0 ? void 0 : requestConfig.data, requestConfig)
        .then(function (response) {
        var data = response.data;
        return data;
    })
        .catch(function (error) {
        return Promise.reject(error);
    });
};
export default httpPost;
